import { Typography } from "@mui/material";
import React from "react";

const DisplayTime = ({ date, time }) => {
    const formattedDate = new Date(time);

    // Get the time components (hours, minutes, and seconds)
    const hours = formattedDate.getUTCHours();
    const minutes = formattedDate.getUTCMinutes();
    const seconds = formattedDate.getUTCSeconds();

    // Format the time as HH:MM:SS
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return (
    <Typography
      variant="subtitle2"
      color="text.primary"
      fontWeight="550"
      fontSize="12px"  
    >
      {date} {formattedTime}
    </Typography>
  );
};

export default DisplayTime;
